import { SET_CLIENT_DATA } from './types'
import { contentPage } from 'src/services/ContentApi'

export const clientData = (language) => async (dispatch) => {
  try {
    const data = await contentPage('page_client_intake', language)
    dispatch({ type: SET_CLIENT_DATA, payload: data })
  } catch (error) {
    throw error
  }
}
